@if (hostWidth) {
  <!-- White container placeholder behind the chart skeleton, matching the loaded card body. -->
  <div class="px-2 w-full absolute top-0 left-0 z-[-1] flex">
    <div class="grow flex flex-col px-6 py-4 rounded-radius-container bg-background-container-primary h-[260px]"></div>
  </div>

  <!-- Chart area: a row of placeholder bars. -->
  <app-loading-skeleton
    class="shrink-0 w-full h-[260px]"
    [viewBox]="'0 0 ' + hostWidth + ' 260'"
    backgroundTextClass="text-background-fixed"
  >
    <svg:rect x="48" y="120" rx="3" ry="3" width="24px" height="100px" />
    <svg:rect x="104" y="80" rx="3" ry="3" width="24px" height="140px" />
    <svg:rect x="160" y="150" rx="3" ry="3" width="24px" height="70px" />
    <svg:rect x="216" y="60" rx="3" ry="3" width="24px" height="160px" />
    <svg:rect x="272" y="110" rx="3" ry="3" width="24px" height="110px" />
    <svg:rect x="328" y="90" rx="3" ry="3" width="24px" height="130px" />
    <svg:rect x="384" y="140" rx="3" ry="3" width="24px" height="80px" />
    <svg:rect x="440" y="70" rx="3" ry="3" width="24px" height="150px" />
    <svg:rect x="496" y="120" rx="3" ry="3" width="24px" height="100px" />
    <svg:rect x="552" y="100" rx="3" ry="3" width="24px" height="120px" />
  </app-loading-skeleton>

  <!-- Legend row below the chart. -->
  <app-loading-skeleton
    class="shrink-0 w-full h-[24px] mt-4 px-6"
    [viewBox]="'0 0 ' + hostWidth + ' 24'"
    backgroundTextClass="text-background-fixed"
  >
    <svg:rect x="0" y="6" rx="6" ry="6" width="12px" height="12px" />
    <svg:rect x="20" y="4" rx="4" ry="4" width="120px" height="16px" />
    <svg:rect x="164" y="6" rx="6" ry="6" width="12px" height="12px" />
    <svg:rect x="184" y="4" rx="4" ry="4" width="120px" height="16px" />
    <svg:rect x="328" y="6" rx="6" ry="6" width="12px" height="12px" />
    <svg:rect x="348" y="4" rx="4" ry="4" width="60px" height="16px" />
  </app-loading-skeleton>
}
